import { datatypes, inputTypes } from "data/globalData";
import {
	blueShade2,
	blueShade3,
	brandColumn,
	channelColumn,
	defRenderCellWithSX,
	defRenderHeaderWithSX,
	generateAopBqSaleDataCacheKey,
	tableBorderStyle,
} from "../data";
import moment from "moment";
import axios from "axios";
import { isStartDateGraterThanEndDate } from "utils/customDateFunctions";
import { multiSort } from "utils/multiColumnSort";
import dayjs from "dayjs";

const renderCellStyle = {
	boxSizing: "border-box",
	borderBottom: tableBorderStyle,
	borderRight: tableBorderStyle,
};

export const projectionTaxColumn = {
	name: "PROJECTION TAX %",
	key: "PROJ_TAX_PRECENT",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.NUMBER.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: 11,
	renderHeader: defRenderHeaderWithSX({
		background: blueShade2,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	}),
	renderCell: defRenderCellWithSX({
		...renderCellStyle,
		background: blueShade3,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	}),
	headerClassName: "blue-header",
	unit: "INR CR.",
	editable: true,
};
export const mrpToCogsRatioColumn = {
	name: "MRP TO COGS %",
	key: "PROJ_COGS_PERCENT",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.NUMBER.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: 15,
	renderHeader: defRenderHeaderWithSX({
		background: blueShade2,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	}),
	renderCell: defRenderCellWithSX({
		...renderCellStyle,
		background: blueShade3,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	}),
	headerClassName: "blue-header",
	unit: "INR CR.",
	editable: true,
};

export const handleProjectionModalEditRow = (updatedRow) => {
	const PROJ_NSV = parseFloat(updatedRow.PROJ_NSV);
	const PROJ_DIS = parseFloat(updatedRow.PROJ_DIS);
	let newObj;
	if (!isNaN(PROJ_NSV) && !isNaN(PROJ_DIS)) {
		newObj = {
			...updatedRow,
			PROJ_NSV,
			PROJ_DIS,
		};
		return newObj;
	}
};

export const projectionEditModalTableColumns = {
	PROJ_NSV: {
		name: "NSV",
		key: "PROJ_NSV",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeaderWithSX({
			background: blueShade2,
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		}),
		renderCell: defRenderCellWithSX({
			...renderCellStyle,
			background: blueShade3,
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		}),
		headerClassName: "blue-header",
		unit: "INR CR.",
		editable: true,
	},
	PROJ_DIS: {
		name: "DIS",
		key: "PROJ_DIS",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeaderWithSX({
			background: blueShade2,
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		}),
		renderCell: defRenderCellWithSX({
			...renderCellStyle,
			background: blueShade3,
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		}),
		headerClassName: "blue-header",
		unit: "% OF REV",
		editable: true,
	},
};

export const setBqDataInRow = (bqRow, rowToUpdate) => {
	return {
		...rowToUpdate,
		NSV_AOP_VAL: rowToUpdate["NSV_AOP_VAL"] + bqRow["NSV_AOP_VAL"],
		NSV_ACH_VAL: rowToUpdate["NSV_ACH_VAL"] + bqRow["NSV_ACH_VAL"],
		CM_GP_AOP_VAL: rowToUpdate["CM_GP_AOP_VAL"] + bqRow["CM_GP_AOP_VAL"],
		CM_GP_ACH_VAL: rowToUpdate["CM_GP_ACH_VAL"] + bqRow["CM_GP_ACH_VAL"],
		CM_TAXABLE_AOP_VAL: rowToUpdate["CM_TAXABLE_AOP_VAL"] + bqRow["CM_TAXABLE_AOP_VAL"],
		CM_TAXABLE_ACH_VAL: rowToUpdate["CM_TAXABLE_ACH_VAL"] + bqRow["CM_TAXABLE_ACH_VAL"],
		GP_ACH_VAL: rowToUpdate["GP_ACH_VAL"] + bqRow["GP_ACH_VAL"],
		GP_AOP_VAL: rowToUpdate["GP_AOP_VAL"] + bqRow["GP_AOP_VAL"],
		TAXABLE_ACH_VAL: rowToUpdate["TAXABLE_ACH_VAL"] + bqRow["TAXABLE_ACH_VAL"],
		TAXABLE_AOP_VAL: rowToUpdate["TAXABLE_AOP_VAL"] + bqRow["TAXABLE_AOP_VAL"],
		MRP_REV: rowToUpdate["MRP_REV"] + bqRow["MRP_REV"],
		COGS_REV: rowToUpdate["COGS_REV"] + bqRow["MRP_REV"],
		LAST_DATE: isStartDateGraterThanEndDate(rowToUpdate["LAST_DATE"], bqRow["LAST_DATE"])
			? rowToUpdate["LAST_DATE"]
			: bqRow["LAST_DATE"],
	};
};

export const setAopProjectionDatainRow = (sqlRow, rowToUpdate) => {
	return {
		...rowToUpdate,
		PROJ_NSV: rowToUpdate["PROJ_NSV"] + sqlRow["PROJ_NSV"],
		PROJ_CM_TAXABLE_VAL: rowToUpdate["PROJ_CM_TAXABLE_VAL"] + sqlRow["PROJ_CM_TAXABLE_VAL"],
		PROJ_TAX: rowToUpdate["PROJ_TAX"] + sqlRow["PROJ_TAX"],
		PROJ_TOTAL_MRP: rowToUpdate["PROJ_TOTAL_MRP"] + sqlRow["PROJ_TOTAL_MRP"],
		PROJ_TOTAL_COGS: rowToUpdate["PROJ_TOTAL_COGS"] + sqlRow["PROJ_TOTAL_COGS"],
	};
};

export const defBqRowData = {
	NSV_AOP_VAL: 0,
	NSV_ACH_VAL: 0,
	CM_GP_AOP_VAL: 0,
	GP_AOP_VAL: 0,
	CM_GP_ACH_VAL: 0,
	GP_ACH_VAL: 0,
	CM_TAXABLE_AOP_VAL: 0,
	TAXABLE_AOP_VAL: 0,
	CM_TAXABLE_ACH_VAL: 0,
	TAXABLE_ACH_VAL: 0,
	MRP_REV: 0,
	COGS_REV: 0,
	LAST_DATE: moment().format("YYYY-MM-DD"),
	// BRAND: "",
	// CHANNEL: "",
};

export const defSqlRowData = {
	PROJ_NSV: 0,
	PROJ_DIS: 0,
	PROJ_TAX_PRECENT: 0,
	PROJ_COGS_PERCENT: 0,
	LAST_UPDATED_BY: "",
	// PROJ_TOTAL_MRP: 0,
	// BRAND: "", CHANNEL: ""
};
export const defAOPOtherData = {
	PROJ_TOTAL_MRP: 0,
};
const fetchBqData = async (dateRange, setCache, getCache) => {
	try {
		const cacheKey = generateAopBqSaleDataCacheKey(dateRange);
		const cached = getCache(cacheKey);
		if (cached) {
			console.log("loaded bq page data from cache");
			return new Promise(async (reslove, rej) => {
				reslove(cached);
			});
		}
		const res = await axios.get(
			`/api/aop/get_bq_sale_data?startDate=${moment(dateRange?.startDate).format("YYYY-MM-DD")}&endDate=${moment(
				dateRange?.endDate
			).format("YYYY-MM-DD")}`
		);
		setCache(cacheKey, res.data.result);
		return res.data.result;
	} catch (error) {
		return [];
	}
};
const fetchBqProjectionData = async (dateRange) => {
	try {
		const res = await axios.get(
			`/api/aop/get_aop_projection_data_monthly?startDate=${moment(dateRange?.startDate).format("YYYY-MM-DD")}&endDate=${moment(
				dateRange?.endDate
			).format("YYYY-MM-DD")}`
		);
		return res.data.result;
	} catch (error) {
		return [];
	}
};
export const generateAopDataCacheKey = (dateRange) => {
	return `AOP-MONTHLY-${dayjs(dateRange.startDate).format("YYYY-MM-DD")}-${dayjs(dateRange.endDate).format("YYYY-MM-DD")}`;
};
export const fetchAOPPageDataFromScratch = async (dateRange, setCache, getCache) => {
	const [bqData, sqlData] = await Promise.all([fetchBqData(dateRange, setCache, getCache), fetchBqProjectionData(dateRange)]);

	const distinctBrands = [
		...new Set(
			[...bqData, ...sqlData].reduce((acc, row) => {
				if (row?.[brandColumn.key]) acc.push(row?.[brandColumn.key]);

				return acc;
			}, [])
		),
	];
	const distinctChannels = [
		...new Set(
			[...bqData, ...sqlData].reduce((acc, row) => {
				if (row?.[channelColumn.key]) acc.push(row?.[channelColumn.key]);
				return acc;
			}, [])
		),
	];
	const filterDropdowns = {
		[brandColumn.key]: distinctBrands,
		[channelColumn.key]: distinctChannels,
	};

	const combineBqAndSqlDataOnBrandChannel = (sqlData, bqData) => {
		const set = new Set(
			[...sqlData, ...bqData]?.map((row) => {
				return `${row.BRAND ?? "BR"}-${row.CHANNEL ?? "CH"}`;
			}, [])
		);
		const sqlDataObj = sqlData?.reduce((acc, row) => {
			acc[`${row.BRAND ?? "BR"}-${row.CHANNEL ?? "CH"}`] = row;
			return acc;
		}, {});
		const bqDataObj = bqData?.reduce((acc, row) => {
			acc[`${row.BRAND ?? "BR"}-${row.CHANNEL ?? "CH"}`] = row;
			return acc;
		}, {});
		const res = [...set].map((key) => {
			let obj = {};
			if (sqlDataObj[key]) obj = { ...obj, ...defSqlRowData, ...sqlDataObj[key] };
			else obj = { ...obj, ...defSqlRowData };
			if (bqDataObj[key]) obj = { ...obj, ...defBqRowData, ...bqDataObj[key] };
			else obj = { ...obj, ...defBqRowData };

			return obj;
		});
		const thor = res
			.filter((row) => row[brandColumn.key] === "THOR")
			.sort(
				multiSort([
					{ key: "BRAND", order: "asc" },
					{ key: "NSV_ACH_VAL", order: "desc" },
				])
			);
		const withoutThor = res
			.filter((row) => row[brandColumn.key] !== "THOR")
			.sort(
				multiSort([
					{ key: "BRAND", order: "asc" },
					{ key: "NSV_ACH_VAL", order: "desc" },
				])
			);

		return [...thor, ...withoutThor];
	};
	const fullData = combineBqAndSqlDataOnBrandChannel(sqlData, bqData)?.filter((row) => row?.BRAND !== "THOR");

	return { fullData, filterDropdowns };
};
export const prepareAllAopTableDataBasedOnCombinedData = (fullDataArr) => {
	const brandTableData = () => {
		const distinctBrands = [
			...new Set(
				fullDataArr.reduce((acc, row) => {
					if (row?.[brandColumn.key]) acc.push(row?.[brandColumn.key]);

					return acc;
				}, [])
			),
		];
		return Object.values(
			distinctBrands.reduce((acc, BRAND) => {
				let dataRow = { ...defBqRowData, ...defSqlRowData, ...defAOPOtherData, [brandColumn.key]: BRAND };
				fullDataArr
					?.filter((row) => row?.[brandColumn.key] === BRAND)
					.forEach((row) => {
						dataRow = setBqDataInRow(row, dataRow);
						dataRow = setAopProjectionDatainRow(row, dataRow); //set both sql and Bq Column Data
					});

				acc = { ...acc, [dataRow[brandColumn.key]]: dataRow };
				return acc;
			}, {})
		).sort((a, b) => b.NSV_ACH_VAL - a.NSV_ACH_VAL);
	};
	const channelTableData = () => {
		const distinctChannels = [
			...new Set(
				fullDataArr.reduce((acc, row) => {
					if (row?.[channelColumn.key]) acc.push(row?.[channelColumn.key]);
					return acc;
				}, [])
			),
		];
		return Object.values(
			distinctChannels.reduce((acc, channelStr) => {
				let dataRow = { ...defBqRowData, ...defSqlRowData, ...defAOPOtherData, [channelColumn.key]: channelStr };
				fullDataArr
					?.filter((row) => row?.[channelColumn.key] === channelStr && row?.[brandColumn.key] !== "THOR")
					.forEach((row) => {
						dataRow = setBqDataInRow(row, dataRow);
						dataRow = setAopProjectionDatainRow(row, dataRow);
					});

				acc = { ...acc, [dataRow[channelColumn.key]]: dataRow };
				return acc;
			}, {})
		).sort((a, b) => b.NSV_ACH_VAL - a.NSV_ACH_VAL);
	};
	const fullCombinedData = () => {
		return fullDataArr;
	};
	console.log(fullCombinedData(), brandTableData(), channelTableData(), "combined page data");
	return {
		brandTableData: brandTableData(),
		channelTableData: channelTableData(),
		combinedTableData: fullCombinedData(),
	};
};
